import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=564746fa&"
import script from "./AlertModal.vue?vue&type=script&lang=ts&"
export * from "./AlertModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports